import { useRef, useEffect } from 'react';

/**
 * This hook get the previous prop value
 */

function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
}

export { usePrevious as u };
//# sourceMappingURL=usePrevious-edd83563.js.map
